import './mix&twist/style';
import FormStructure from './mix&twist/form_structure';

export default FormStructure;